import { render, staticRenderFns } from "./OkModal.vue?vue&type=template&id=49827843&scoped=true&"
import script from "./OkModal.vue?vue&type=script&lang=ts&"
export * from "./OkModal.vue?vue&type=script&lang=ts&"
import style0 from "./OkModal.vue?vue&type=style&index=0&id=49827843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49827843",
  null
  
)

export default component.exports